// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fw-shell-body {
  padding: 16px;
  font-family: Lato, sans-serif;
  color: #0b1e2d;
}

.fw-source-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  background: #f7fafa;
  border: 1px solid #dfe7e8;
  border-radius: 10px;
  padding: 14px 16px;
  margin-bottom: 16px;
}

.fw-stat {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  min-width: 0;
  flex: 0 1 auto;
}

.fw-stat-label {
  font-family: Lato, sans-serif;
  font-weight: 700;
  font-size: 13.5px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #5f7484;
}

.fw-stat-divider {
  width: 1px;
  height: 34px;
  background: #dfe7e8;
  flex-shrink: 0;
}

.fw-stat-value {
  font-size: 16.5px;
  font-weight: 500;
  margin-top: 3px;
  color: #0b1e2d;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.fw-mono {
  font-variant-numeric: tabular-nums;
}

.fw-ghost-btn {
  margin-left: auto;
  align-self: center;
  display: inline-flex;
  align-items: center;
  height: 36px;
  padding: 0 14px;
  border-radius: 8px;
  font-family: Lato, sans-serif;
  font-size: 14.5px;
  font-weight: 500;
  color: #0b1e2d;
  background: #fff;
  border: 1px solid #dfe7e8;
  cursor: pointer;
  transition: background 0.14s, border-color 0.14s;
}

.fw-ghost-btn:hover {
  background: #eff3f4;
  border-color: #8a9ba7;
}

.fw-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  align-items: stretch;
}

/* Buttons do not stretch as grid items, so the slot takes the row height. */
.fw-card-slot {
  display: flex;
  min-width: 0;
  min-height: 100%;
}

.fw-card {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  box-sizing: border-box;
  /* Global \`button { width: fit-content !important }\` would shrink each card. */
  width: 100% !important;
  max-width: none !important;
  min-width: 0;
  flex: 1 1 auto;
  height: auto;
  min-height: 100%;
  gap: 10px;
  text-align: left;
  background: #fff;
  border: 1px solid #dfe7e8;
  border-radius: 10px;
  padding: 18px;
  box-shadow: 0 1px 2px rgba(6, 21, 36, 0.04);
  cursor: pointer;
  font-family: Lato, sans-serif;
  font-size: inherit;
  color: inherit;
  appearance: none;
  outline: none;
  transition: border-color 0.16s, transform 0.16s, box-shadow 0.16s;
}

.fw-card:hover {
  border-color: #0d9b87;
  transform: translateY(-2px);
  box-shadow: 0 8px 26px -16px rgba(6, 21, 36, 0.5);
}

.fw-card:focus-visible {
  outline: 2px solid #0d9b87;
  outline-offset: 2px;
}

.fw-card.current {
  border-color: #0d9b87;
  background: linear-gradient(180deg, #f4fcfb, #fff);
}

.fw-ic {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 9px;
  display: grid;
  place-items: center;
  background: #e1f4f0;
  color: #076b5c;
}

.fw-ic svg {
  width: 16px;
  height: 16px;
}

.fw-name {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
  width: 100%;
  font-size: 16.5px;
  font-weight: 600;
  color: #0b1e2d;
  line-height: 1.35;
  min-height: calc(1.35em * 2);
  max-height: calc(1.35em * 2);
}

.fw-name em {
  font-style: normal;
  font-weight: 400;
  color: #5f7484;
  font-size: 14px;
}

.fw-desc {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  overflow: hidden;
  width: 100%;
  align-self: stretch;
  font-size: 15px;
  color: #5f7484;
  line-height: 1.55;
  min-height: calc(1.55em * 3);
  max-height: calc(1.55em * 3);
}

.fw-cta {
  display: block;
  align-self: stretch;
  width: 100%;
  margin-top: auto;
  padding-top: 4px;
  font-size: 14.5px;
  font-weight: 500;
  color: #076b5c;
  line-height: 1.3;
}

.fw-card.current .fw-cta {
  color: #5f7484;
}

.fw-empty {
  padding: 48px 16px;
  text-align: center;
  color: #5f7484;
  font-size: 14px;
}

@media (max-width: 1100px) {
  .fw-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 760px) {
  .fw-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .fw-ghost-btn {
    margin-left: 0;
    width: 100% !important;
    justify-content: center;
  }

  .fw-stat-divider {
    display: none;
  }

  .fw-name {
    min-height: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/securityFramework/SecurityFramework.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,oBAAoB;AACtB;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,8EAA8E;EAC9E,sBAAsB;EACtB,0BAA0B;EAC1B,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,iEAAiE;AACnE;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,iDAAiD;AACnD;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".fw-shell-body {\n  padding: 16px;\n  font-family: Lato, sans-serif;\n  color: #0b1e2d;\n}\n\n.fw-source-bar {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n  background: #f7fafa;\n  border: 1px solid #dfe7e8;\n  border-radius: 10px;\n  padding: 14px 16px;\n  margin-bottom: 16px;\n}\n\n.fw-stat {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  min-width: 0;\n  flex: 0 1 auto;\n}\n\n.fw-stat-label {\n  font-family: Lato, sans-serif;\n  font-weight: 700;\n  font-size: 13.5px;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: #5f7484;\n}\n\n.fw-stat-divider {\n  width: 1px;\n  height: 34px;\n  background: #dfe7e8;\n  flex-shrink: 0;\n}\n\n.fw-stat-value {\n  font-size: 16.5px;\n  font-weight: 500;\n  margin-top: 3px;\n  color: #0b1e2d;\n  line-height: 1.35;\n  overflow-wrap: anywhere;\n}\n\n.fw-mono {\n  font-variant-numeric: tabular-nums;\n}\n\n.fw-ghost-btn {\n  margin-left: auto;\n  align-self: center;\n  display: inline-flex;\n  align-items: center;\n  height: 36px;\n  padding: 0 14px;\n  border-radius: 8px;\n  font-family: Lato, sans-serif;\n  font-size: 14.5px;\n  font-weight: 500;\n  color: #0b1e2d;\n  background: #fff;\n  border: 1px solid #dfe7e8;\n  cursor: pointer;\n  transition: background 0.14s, border-color 0.14s;\n}\n\n.fw-ghost-btn:hover {\n  background: #eff3f4;\n  border-color: #8a9ba7;\n}\n\n.fw-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px;\n  align-items: stretch;\n}\n\n/* Buttons do not stretch as grid items, so the slot takes the row height. */\n.fw-card-slot {\n  display: flex;\n  min-width: 0;\n  min-height: 100%;\n}\n\n.fw-card {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  box-sizing: border-box;\n  /* Global `button { width: fit-content !important }` would shrink each card. */\n  width: 100% !important;\n  max-width: none !important;\n  min-width: 0;\n  flex: 1 1 auto;\n  height: auto;\n  min-height: 100%;\n  gap: 10px;\n  text-align: left;\n  background: #fff;\n  border: 1px solid #dfe7e8;\n  border-radius: 10px;\n  padding: 18px;\n  box-shadow: 0 1px 2px rgba(6, 21, 36, 0.04);\n  cursor: pointer;\n  font-family: Lato, sans-serif;\n  font-size: inherit;\n  color: inherit;\n  appearance: none;\n  outline: none;\n  transition: border-color 0.16s, transform 0.16s, box-shadow 0.16s;\n}\n\n.fw-card:hover {\n  border-color: #0d9b87;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 26px -16px rgba(6, 21, 36, 0.5);\n}\n\n.fw-card:focus-visible {\n  outline: 2px solid #0d9b87;\n  outline-offset: 2px;\n}\n\n.fw-card.current {\n  border-color: #0d9b87;\n  background: linear-gradient(180deg, #f4fcfb, #fff);\n}\n\n.fw-ic {\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n  border-radius: 9px;\n  display: grid;\n  place-items: center;\n  background: #e1f4f0;\n  color: #076b5c;\n}\n\n.fw-ic svg {\n  width: 16px;\n  height: 16px;\n}\n\n.fw-name {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  overflow: hidden;\n  width: 100%;\n  font-size: 16.5px;\n  font-weight: 600;\n  color: #0b1e2d;\n  line-height: 1.35;\n  min-height: calc(1.35em * 2);\n  max-height: calc(1.35em * 2);\n}\n\n.fw-name em {\n  font-style: normal;\n  font-weight: 400;\n  color: #5f7484;\n  font-size: 14px;\n}\n\n.fw-desc {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  line-clamp: 3;\n  overflow: hidden;\n  width: 100%;\n  align-self: stretch;\n  font-size: 15px;\n  color: #5f7484;\n  line-height: 1.55;\n  min-height: calc(1.55em * 3);\n  max-height: calc(1.55em * 3);\n}\n\n.fw-cta {\n  display: block;\n  align-self: stretch;\n  width: 100%;\n  margin-top: auto;\n  padding-top: 4px;\n  font-size: 14.5px;\n  font-weight: 500;\n  color: #076b5c;\n  line-height: 1.3;\n}\n\n.fw-card.current .fw-cta {\n  color: #5f7484;\n}\n\n.fw-empty {\n  padding: 48px 16px;\n  text-align: center;\n  color: #5f7484;\n  font-size: 14px;\n}\n\n@media (max-width: 1100px) {\n  .fw-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 760px) {\n  .fw-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .fw-ghost-btn {\n    margin-left: 0;\n    width: 100% !important;\n    justify-content: center;\n  }\n\n  .fw-stat-divider {\n    display: none;\n  }\n\n  .fw-name {\n    min-height: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
